"use client";

import { PropsWithChildren, useEffect, useRef } from "react";
import { useAppDispatch } from "stores/hooks";
import { markUI } from "stores/ui/uiSlice";
import { useMediaQuery } from "utils/hooks/useMediaQuery";
const PropertyItemWrapper = ({
  children,
  property_id
}: PropsWithChildren<{
  property_id: string;
}>) => {
  const dispatch = useAppDispatch();
  const [isMapPricePillsVisible] = useMediaQuery("(min-width: 1280px)");
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (isMapPricePillsVisible) {
      ref.current?.addEventListener("mouseenter", () => {
        dispatch(markUI({
          hoveredPropertyId: property_id
        }));
      }, {
        passive: true
      });
      ref.current?.addEventListener("mouseleave", () => {
        dispatch(markUI({
          hoveredPropertyId: null
        }));
      }, {
        passive: true
      });
    } else {
      ref.current?.removeEventListener("mouseenter", () => {});
      ref.current?.removeEventListener("mouseleave", () => {});
    }
  }, [dispatch, isMapPricePillsVisible, property_id]);
  return <div ref={ref} data-sentry-component="PropertyItemWrapper" data-sentry-source-file="PropertyItemWrapper.tsx">{children}</div>;
};
export default PropertyItemWrapper;